import { View, Pressable, StyleSheet, type ViewStyle, type StyleProp } from 'react-native';

import { rippleOnSurface, useAppTheme } from '@/theme';

import { AppSearchbar } from '@/components/atoms';

interface Props {
  readonly onPress: () => void;
  readonly placeholder: string;
  readonly style?: StyleProp<ViewStyle>;
}

const styles = StyleSheet.create({
  pressable: {
    borderRadius: 28,
    overflow: 'hidden',
  },
});

export const SearchTrigger = ({ onPress, placeholder, style }: Props) => {
  const theme = useAppTheme();

  return (
    <Pressable
      android_ripple={{ color: rippleOnSurface }}
      onPress={onPress}
      style={[styles.pressable, style]}
      testID="search-trigger-pressable">
      <View pointerEvents="none">
        <AppSearchbar
          placeholder={placeholder}
          value=""
          editable={false}
          elevation={0}
          placeholderTextColor={theme.colors.textNdMuted}
          style={{
            backgroundColor: theme.colors.bgNlBase,
            borderWidth: 1,
            borderColor: theme.colors.outline,
          }}
        />
      </View>
    </Pressable>
  );
};
